var Utility = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods and Variables
     * ========================================================================
    */

    return {
        /**
         * Displays an info toast with the message "This functionality is coming soon :)"
         */
        comingSoon: function () {
            const message = "This functionality is coming soon :)";
            FD.notify.info(message, null, null, { dismissAllNotifications: true });
        },

        /**
         * Create a Ladda button.
         * @param {JQLite} $button
         */
        createLadda: function ($button) {
            if (!$button.hasClass("ladda-button")) {
                $button.addClass('ladda-button').attr('data-style', 'expand-right').append('<span class="ladda-spinner"></span>');
            }

            // start Ladda and save to data
            return Ladda.create($button[0]);
        },

        /**
         * Starts a Ladda button (this function will create it if it isn't already a Ladda button).
         * "this" should be a control_form, a button, or an anchor
         */
        startLadda: function () {
            let $laddaButton;
            if ($(this).is("[data-fd-control=form]")) {
                $laddaButton = $(this).control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
            } else if (this.element && this.element.is("[data-fd-control=form]")) {
                if (this.element.control_form("valid")) {
                    $laddaButton = this.element.control_form("popTriggerElement"); // if we are using an FD form control, the trigger element is what we want
                }
            } else {
                $laddaButton = $("[type=submit]:visible,button:not([type]):visible", this) // find any submit buttons with the "this" as the parent context
                    .add($(this).filter("a,button")); // add this if it is an anchor or a button
            }

            if (!$laddaButton.length) {
                return null; // invalid "this"
            }

            // create and start Ladda
            const ladda = Utility.createLadda($laddaButton).start();
            $laddaButton.data("fd-ladda", ladda);
            return ladda;
        },


        /**
         * Stops a Ladda button
         * "this" should be a or a parent of a Ladda button
         */
        stopLadda: function () {
            const $laddaButton = $(".ladda-button", this) // find all Laddas from the context of "this"
                .add($(this).filter(".ladda-button")); // include this in case it is an anchor or button 

            $laddaButton.each(function () {
                const ladda = $(this).data("fd-ladda");
                if (ladda) {
                    $(this).prop("disabled", false);
                    ladda.stop();
                }
            });
        },

        /**
         * Toggles d-none on all siblings of "this"
         */
        toggleSiblingsDisplay: function () {
            $(this).siblings().add(this).toggleClass("d-none");
        },

        /**
         * Toggles d-none on all children of "this"
         */
        toggleChildrenDisplay: function () {
            $(this).children().toggleClass("d-none");
        },

        /**
         * TODO: not implemented (missing js library possibly...)
         */
        blockUI: function (elem) {
            if (elem) {
                $(elem).block({
                    message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
            } else {
                $.blockUI({
                    message: '<i class="fa fa-fw fa-spinner fa-spin"></i>',
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
            }
        },

        /**
         * TODO: not implemented (missing js library possibly...)
         */
        unblockUI: function (elem) {
            if (elem) {
                $(elem).unblock();
            } else {
                $.unblockUI();
            }
        },

        /**
         * Uses the selector ':input,[data-name]' to collect all values into an object where the names of the elements are properties.
         * All property names are parsed so that if a "." exists, the property name will only be everything up after that point.
         * fd-control types that are supported are: select, number, checkbox, toggle, and datepicker.
         * Other elements that are supported are: toggle buttons, non-inputs (the .text() will be the value), inputs with data-value, and inputs
         * @param {string|JQLite} container An optional parameter that should be a selector or a jQuery object
         */
        getControlValuesByContainer: function (container) {
            const fldList = container ? $(container).find(':input,[data-name]') : $(':input,[data-name]');
            let ctrlAR = {},
                lastElement;

            fldList.each(function () {
                var elem = $(this);
                var fldName = (elem.data('name') ? elem.data('name') : this.name).split('.').pop();
                var controlType = elem.data('fd-control');
                var val;

                if (controlType === 'select') {
                    val = elem.val();
                } else if (controlType === 'number') {
                    val = elem.val();
                } else if (controlType === 'checkbox' || controlType === 'toggle') {
                    if (elem.is(".checkbox-group")) {
                        val = ctrlAR[fldName] || [];
                        if (elem.is(':checked')) {
                            val.push(elem.prev().val());
                        }
                    } else {
                        val = elem.is(':checked');
                    }
                } else if (controlType === 'datepicker') {
                    if (elem.data("type") === 'range') {
                        val = elem.val().split('-');
                        if (val.length > 0) {
                            ctrlAR[fldName + "Start"] = val[0].trim();
                            ctrlAR[fldName + "End"] = val[1].trim();
                            return;
                        }
                    }
                    val = elem.val();
                } else if (elem.hasClass("btn-group") && elem.data("toggle") === "buttons") {
                    val = $("label.btn-primary.active", elem).children()[0].id;
                } else if (controlType === 'button') {
                    return;
                } else if (elem.is(':not(:input)')) {
                    val = elem.text().trim();
                } else {
                    if (lastElement != null && lastElement.is('[data-fd-control=checkbox],[data-fd-control=toggle]') && lastElement.attr('name') == elem.attr('name')) {
                        return;
                    }
                    if (elem.data('value')) {
                        val = elem.data('value');
                    } else {
                        val = elem.val();
                    }
                }

                ctrlAR[fldName] = val;
                lastElement = elem;
            });

            return ctrlAR;
        },

        /**
         * The common function executed when an ajax-unobtrusive fails
         * @param {{status: number, getResponseHeader: function(string): string }} jqXhR
         */
        onFailure: function (jqXhR) {
            Utility.stopLadda.call(this); // in case ladda is running, we will want the user to be able to resubmit

            switch (jqXhR.status) {
                case 400:
                    FD.notify.alert(jqXhR.getResponseHeader('error-message'));
                    break;
                case 401:
                    FD.notify.alert("Unauthorized. Please refresh this page.");
                    break;
                default:
                    FD.notify.alert("An error has occurred. Please try to hard refresh your page.");
                    break;
            }
        },

        /**
         * "this" should have a data-ajaxUpdate attribute that is set to a selector.
         * That selector will have it's jQuery object's FD controls enabled.
         */
        enableControls: function () {
            var self = $($(this).data("ajaxUpdate"));
            self.enableControls();
        },

        /**
         * "this" should be a control_form. It will be reset.
         */
        resetForm: function () {
            $(this).control_form('reset');
        },


        /**
         * Resets a list typically used for posting back to the server.
         * It sequentially updates all indexes.
         * @param {string} itemSelector
         */
        resetSequence: function (itemSelector) {
            let index = 0;
            $(this).children(itemSelector).each(function () {
                $('[name],[data-valmsg-for]', this).each(function () {
                    updateSequance($(this), "name");
                    updateSequance($(this), "data-valmsg-for");
                });
                index++;
            });

            function updateSequance($this, name) {
                if ($this.is('[' + name + ']')) {
                    $this.attr(name, $this.attr(name).replace(/\[\d*\]/, '[' + index + ']'));
                }
            }
        },

        /**
         * Removes an item of a sequence and gracefully handles resetting the sequence.
         * The sequence is a list used typically for posting back to the server.
         * The sequence item removed is returned.
         * @param {string|JQLite} itemSelector
         * @returns {JQLite}
         */
        removeSequenceItem: function (itemSelector) {
            const $item = $(this).closest(itemSelector);
            let parent = $item.parent();
            $(this).popover('dispose');
            $item.find("[title]").tooltip("dispose");
            $(this).closest("form").addClass("dirty");
            const $itemRemoved = $(this).closest(itemSelector).remove();

            Utility.resetSequence.call(parent, itemSelector);

            return $itemRemoved;
        },

        /**
         * Adds an item of a sequence and gracefully handles resetting the sequence.
         * The sequence is a list used typically for posting back to the server.
         * The sequence item added is returned.
         * @param {string|JQLite} templateSelector
         * @param {string|JQLite} insertBeforeSelector
         * @param {string|JQLite} sequenceItemSelector
         * @param {any} dataFdValue the value to set onto inputDataFdValueSelector
         * @param {string|JQLite} inputDataFdValueSelector
         * @returns {JQLite}
         */
        addSequenceItem: function (templateSelector, insertBeforeSelector, sequenceItemSelector, dataFdValue, inputDataFdValueSelector) {
            const item = (typeof templateSelector === "string" ? $(templateSelector) : templateSelector)
                .clone()
                .attr('data-fd-value', dataFdValue)
                .removeAttr('id')
                .insertBefore(insertBeforeSelector)
                .removeClass('d-none')
                .enableControls();
            if (inputDataFdValueSelector) {
                item.find(inputDataFdValueSelector).prop("disabled", false).val(dataFdValue); // if this is a sequence item, there should be a hidden input for form to post the sequence
            }
            item.closest("form").addClass("dirty"); // the form should be marked as dirty
            Utility.resetSequence.call(item.parent(), sequenceItemSelector);
            return item; // return the item for any other page specific updates
        },

        /**
         * JS redirect that also gracefully handles dirty forms.
         * @param {string} url
         */
        redirect: function (url) {
            // persist state and clean dirty form
            $(".d-clean-none:visible").removeClass("d-clean-none");
            $(".d-dirty-none:not(:visible)").addClass("d-none");
            $("form").dirtyForms("setClean").removeClass('force-dirty');

            window.location = url;
        }
    };
}();